import { render, staticRenderFns } from "./SettingsBilling.vue?vue&type=template&id=0f1c5c6a"
import script from "./SettingsBilling.vue?vue&type=script&lang=js"
export * from "./SettingsBilling.vue?vue&type=script&lang=js"
import style0 from "./SettingsBilling.vue?vue&type=style&index=0&id=0f1c5c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports